module.exports = __webpack_public_path__ + "img/up-monitor-filter.193e8f05.svg";